// Prevodi za kod koji nije Vue komponenta (servisi): instancu pravi main.js, a ovde se čuva da se `tr` može pozvati odasvud.
let instance = null;

export const setI18n = (i18n) => {
  instance = i18n;
};

/** Prevod ključa; dok instanca još ne postoji (ili ključa nema) vraća zadati tekst. */
export const tr = (key, fallback = key) => {
  if (!instance) return fallback;
  const text = instance.t(key);
  return text && text !== key ? text : fallback;
};
